import React, { useEffect, useRef, useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import ApMasterTab from "./ApMasterTab";
// import ClientMasteTab from "./ClientMasteTab";
import ClientMasterTab from "./ClientMasterTab";
import axios from "axios";
import { AP_Master } from "../../Configuration/API_URL";
import { toast } from "react-toastify";
// import SmallLoader from "../../Components/Common/smallLoader";
import RoundLoader from "../../Components/Common/RoundRingLoader";
import { Constants } from "../../CommonMethhods/Constants";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../CommonMethhods/CommonMethods";
import { useDebounce } from "../../Components/useDebounce";

function Mastertable(props) {
  const storeToken = localStorage.getItem("ssoToken");
  let LocalSearchRef = useRef("");
  const [activeKey, setActiveKey] = useState("ApMaster");
  const [apMasterDetail, setApMasterDetail] = useState([]);
  const [clientMaster, setClientMaster] = useState([]);
  const [page, setPage] = useState(1);
  const [pageclientM, setPageclientM] = useState(1);
  const [downloadBtnLoader, setDownloadBtn] = useState(false);
  const [count, setCount] = useState();
  const [scrollLoader, setScrollLoader] = useState(false);
  const [clientCount, setClientCount] = useState();
  const [clientScrollLoader, setClientScrollLoader] = useState(false);
  const [mainClientLoader, setMainClientLoader] = useState(false);
  const [mainApMasterLoader, setMainApMasterLoader] = useState(false);
  const [apNotFound, setApNotFound] = useState(false);
  const [clientNotFound, setClientNotFound] = useState(false);
  const [roleMaster, setRoleMaster] = useState("");
  const [searchInput, setSearchInput] = useState("");

  const debouncedValue = useDebounce(searchInput, 1000);

  useEffect(() => {
    handleSearchApMaster(debouncedValue);
  }, [debouncedValue]);

  const getApMasterList = async (
    viewType = "grid",
    pageSize = 10,
    page = 1,
    value = "",
    firstLoad = false
  ) => {
    if (viewType === "grid" && page === 1) {
      setMainApMasterLoader(true);
    }
    let payloadValue = {
      type: viewType,
      pageNo: page,
      pageSize: pageSize,
      search: value,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getApList = await axios.post(
        AP_Master.Get_Ap_Master_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getApList?.data);
      if (res?.status === 0) {
        setApNotFound(false);
        setCount(res?.data?.totalCount);
        if (viewType === "grid") {
          setRoleMaster(res?.data?.role);
          props.checkAccess(res?.data?.role)
          // localStorage.setItem("accessRole", res?.data?.role)
          if (res?.data?.ap) {
            if (firstLoad) {
              setApMasterDetail(res?.data?.ap);
            } else {
              setApMasterDetail((prev) => {
                return [...prev, ...res?.data?.ap];
              });
            }
          }
        } else if (viewType === "excel") {
          if (res?.data) {
            window.open(res?.data, "_self", "noopener,noreferrer");
            toast.success("File Downloaded successfully");
          }
        }
      } else {
        if (viewType === "grid") {
          setApMasterDetail([]);
          setApNotFound(res?.message);
        } else {
          toast.error(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      if (viewType === "grid") {
        setApNotFound(error?.message);
      } else {
        toast.error(error?.message);
      }
    } finally {
      setDownloadBtn(false);
      setScrollLoader(false);
      setMainApMasterLoader(false);
    }
  };

  const handleScrollApMaster = () => {
    const a = document.querySelector("#apMasterpageId");
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
      if (count <= page * 10) {
        // setApScroll(false);
        setScrollLoader(false);
        return;
      }
      setPage((prev) => prev + 1);
      setScrollLoader(true);
    }
  };

  const GetClientMaster = async (
    viewType = "grid",
    pageSize = 10,
    page = 1,
    value = "",
    firstLoad = false
  ) => {
    if (pageclientM < 1 && viewType === "grid") {
      setMainClientLoader(true);
    } else {
      setMainClientLoader(false);
    }
    let payloadValue = {
      type: viewType,
      pageNo: page,
      pageSize: pageSize,
      search: value,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getClientList = await axios.post(
        AP_Master.GetClientMaster_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const getClientListDecrypt = ApiResDecrypt(getClientList?.data);

      const res = getClientListDecrypt.data;
      setClientCount(res.totalCount);
      if (viewType === "grid") {
        if (res?.clientList) {
          if (firstLoad) {
            setClientMaster(res?.clientList);
          } else {
            setClientMaster((prev) => {
              return [...prev, ...res?.clientList];
            });
          }

          setClientNotFound(false);
        } else {
          setClientNotFound(true);
        }
      } else if (viewType === "excel") {
        if (res) {
          window.open(res, "_self", "noopener,noreferrer");
        }
      } else {
        setClientMaster([]);
        toast.error("Fail to load data");
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong, Please try again later.");
    } finally {
      setDownloadBtn(false);
      setMainClientLoader(false);
    }
  };

  const handleScrollClientMaster = () => {
    var s = document.querySelector(`#clientpageId`);
    if (s.scrollTop + s.offsetHeight + 1 >= s.scrollHeight) {
      if (clientCount <= pageclientM * 10) {
        setClientScrollLoader(false);
        return;
      }
      setPageclientM((prev) => prev + 1);
      setClientScrollLoader(true);
    }
  };
  const handleType = () => {
    setDownloadBtn(true);
    if (activeKey === "ApMaster") {
      getApMasterList("excel", -1, 1, searchInput);
    } else if (activeKey === "ClientMaster") {
      GetClientMaster("excel", -1, 1, searchInput);
    } else {
      toast.error("Fail to download");
    }
  };

  const handleSearchApMaster = (data) => {
    if(data){
      if (activeKey === "ApMaster") {
        getApMasterList("grid", 10, page, data, true);
      } else if (activeKey === "ClientMaster") {
        GetClientMaster("grid", 10, pageclientM, data, true);
      }
      setApMasterDetail([]);
    setClientMaster([]);
    setPage(1);
    setPageclientM(1);
      
    }
    // e.target.value = e.target.value.toUpperCase();
    // setSearchInput(e.target.value);
    // setApMasterDetail([]);
    // setClientMaster([]);
    // setPage(1);
    // setPageclientM(1);
    // if (activeKey === "ApMaster") {
    //   getApMasterList("grid", 10, page, e.target.value, true);
    // } else if (activeKey === "ClientMaster") {
    //   GetClientMaster("grid", 10, pageclientM, e.target.value, true);
    // }
  };

  const getApMasterListToParent = () => {
    LocalSearchRef.current.value = "";
    if (activeKey === "ApMaster") {
      setApMasterDetail([]);
      getApMasterList();
    } else if (activeKey === "ClientMaster") {
      setClientMaster([]);
      GetClientMaster();
    }

    let a = document.querySelector("#for-scroll-left");
    a.scrollTo({ left: 0, behavior: "smooth" });
  };
  props.hiRef.getApMasterListToParent = getApMasterListToParent;

  const UpdateRemarkAPI = async (code, status, textArea, type) => {
    let payloadValue = {
      apcode: code,
      type: type,
      remarks: textArea,
      status: status,
    };
    console.log(payloadValue, "payloadValue");
    let encPayload = AESEncryption(payloadValue);
    try {
      const getClientList = await axios.post(
        AP_Master.UpdateRemark_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getClientList?.data);
      if (res?.status === 0) {
        toast.success(res?.data);
        getApMasterListToParent();
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message);
    }
  };

  useEffect(() => {
    if (activeKey === "ApMaster") {
      getApMasterList("grid", 10, page);
    } else if (activeKey === "ClientMaster") {
      GetClientMaster("grid", 10, pageclientM);
    }
  }, [page, pageclientM, activeKey]);

  return (
    <div className="master-table-wrapper">
      <div className="tableHead">
        <h4 className="master-title">Master Table</h4>
        <button type="button" className="downloadBtn" onClick={handleType}>
          {downloadBtnLoader ? (
            <div className="download-loader">
              <RoundLoader h={"20"} />
            </div>
          ) : (
            "Download"
          )}
        </button>
      </div>

      <div className="tab-content" id="myTabContent">
        <Tab.Container id="left-tabs-example" activeKey={activeKey}>
          {/* page tabs */}
          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <Nav variant="nav tabs page-tabs">
                <li
                  className="nav-item"
                  onClick={() => {
                    setActiveKey("ApMaster");
                    props.masterSet("ApMaster");
                    setPage(1);
                    setPageclientM(1);
                    props.reset();
                    LocalSearchRef.current.value = "";
                  }}
                >
                  <Nav.Link eventKey="ApMaster">AP Master</Nav.Link>
                </li>
              </Nav>
              <Nav variant="nav tabs page-tabs">
                <li
                  className="nav-item"
                  // disabled
                  // style={{ cursor: "not-allowed" }}
                  onClick={() => {
                    setActiveKey("ClientMaster");
                    setPage(1);
                    setPageclientM(1);
                    props.masterSet("ClientMaster");
                    LocalSearchRef.current.value = "";
                    props.reset();
                  }}
                >
                  <Nav.Link eventKey="ClientMaster">Client Master</Nav.Link>
                </li>
              </Nav>
            </div>
            <div className="form-group">
              {/* <label className="form-label">{Constants.Client_Search} </label> */}
              <input
                type="text"
                name="search-text"
                id="SearchInput"
                ref={LocalSearchRef}
                className="input-st mt-3 h-75"
                value={searchInput}
                placeholder="Search here..."
                autoComplete="off"
                onChange={(e) => {
                  setSearchInput(e.target?.value?.toUpperCase());
                }}
              />
            </div>
          </div>
          {/* page tabs end */}

          <div className="for-grid-section">
            <Tab.Content>
              <ApMasterTab
                apMasterDetail={apMasterDetail}
                forUpdateMaster={props.forUpdateMaster}
                handleScrollApMaster={handleScrollApMaster}
                scrollLoader={scrollLoader}
                apNotFound={apNotFound}
                UpdateRemarkAPI={UpdateRemarkAPI}
                roleMaster={roleMaster}
                mainApMasterLoader={mainApMasterLoader}
              />
              <ClientMasterTab
                clientMaster={clientMaster}
                clientScrollLoader={clientScrollLoader}
                mainClientLoader={mainClientLoader}
                forUpdateMaster={props.forUpdateMaster}
                handleScrollClientMaster={handleScrollClientMaster}
                clientNotFound={clientNotFound}
              />
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>
    </div>
  );
}

export default Mastertable;
